import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects';
import { AppSettings } from '../constants';
import { sendAjaxRequest } from 'helper/interceptors';
import {
  awaitingReview,
  approve,
  close,
  getByRFSID,
  search,
  getListWorkOrderByRFSID,
  signoffMultipleWorkOrder,
  reportSelectListRegion,
  reportSelectListMarket,
  reportSelectListProject,
  reportSelectListRequestType,
  reportSelectListLot,
  getRFSHistory,
  AddHomeownerRequest,
  updateRFSWithoutChangeStatus,
  signOffMultipleHomeownerWorkOrder,
  updateRFSManageBy,
  exportRFSList,
  reassignMultipleRFS,
  printPreviewRFS,
  fetchRequestElectricOrientationCheckList,
  fetchRequestElectricOrientationCheckList2,
  printEOCTemplate,
  printEOFTemplate,
  printEPLTemplate,
  requestSignatureEOC,
  requestCheckListSignatureEOC,
  requestCheckListsApprovalEOC,
  submitElectricOrientationCheckLists,
  submitElectricOrientationCheckLists2,
  eocTemplateHomeowner,
  getRFSEndpoint,
  eocSubmitTemplateHomeowner,
  homeownerRFSSetupAWS,
  uploadS3Signature,
  saveEocFormToLotDocument,
  sendEOCTemplateEmail,
  sendEPLTemplateEmail,
  getEmailPrimaryHomeowner,
  updateRFSRequestType,
  getCheckEPLIsAvailable,
  fetchCreatedBy,
  updateWOReassignValue,
  // fetchAverageAgeAPI,
  getRFSREviewDate
} from './api';
import * as RFSActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* awaitingReviewAsync(action) {
  const result = yield call(awaitingReview, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: NotifyActionType.NOTIFY_SUCCESS,
        data: 'Request for service created'
      })
    ];
  } else {
    yield put({
      type: RFSActionType.ADD_EDIT_RFS_ERROR,
      data: { error: result.data, params: action.params.data }
    });
  }
}

export function* homeownerRFSSetupAWSAsync(action) {
  const result = yield call(homeownerRFSSetupAWS, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) { action.callback(result.data); }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* approveAsync(action) {
  const result = yield call(approve, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: NotifyActionType.NOTIFY_SUCCESS,
        data: 'Request for service created'
      })
    ];
  } else {
    yield put({
      type: RFSActionType.ADD_EDIT_RFS_ERROR,
      data: { error: result.data, params: action.params.data }
    });
  }
}

export function* closeAsync(action) {
  const result = yield call(close, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: NotifyActionType.NOTIFY_SUCCESS,
        data: 'Request for service created'
      })
    ];
  } else {
    yield put({
      type: RFSActionType.ADD_EDIT_RFS_ERROR,
      data: { error: result.data, params: action.params.data }
    });
  }
}

export function* getByRFSIDAsync(action) {
  const result = yield call(getByRFSID, action.params, action.isLoading);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RFSActionType.GET_BY_RFS_ID_SUCCESS, data: result.data })
    ];

    if (action.callback) {
      action.callback(result.data);
    }
  }
  else {
    if (action.onError) {
      action.onError();
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* updateRFSWithoutChangeStatusAsync(action) {
  const result = yield call(updateRFSWithoutChangeStatus, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' }),
      put({
        type: RFSActionType.GET_BY_RFS_ID_ASYNC,
        params: action.params.refNo
      })
    ];
    if (action.callback) {
      action.callback(true);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* searchAsync(action) {
  const result = yield call(search, action.params);
  console.log('searchAsync',result)
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: RFSActionType.SEARCH_RFS_SUCCESS,
      data: {
        data: result.data,
        params: action.params
      }
    });

    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* addRFSAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    'api/request-for-services',
    action.payload,
    'POST'
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: RFSActionType.ADD_RFS_SUCCESS,
        data: {
          data: result.data
        }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'RFS created' })
    ];

    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* getListWorkOrderByRFSIDAsync(action) {
  const result = yield call(getListWorkOrderByRFSID, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield put({
      type: RFSActionType.GET_LIST_WORK_ORDER_BY_RFSID_SUCCESS,
      data: result.data
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* signoffMultipleWorkOrderAsync(action) {
  const result = yield call(signoffMultipleWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* reportSelectListRegionAsync(action) {
  const result = yield call(reportSelectListRegion, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: RFSActionType.REPORT_SELECT_LIST_REGION_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* reportSelectListMarketAsync(action) {
  const result = yield call(reportSelectListMarket, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: RFSActionType.REPORT_SELECT_LIST_MARKET_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* reportSelectListRequestTypeAsync(action) {
  const result = yield call(reportSelectListRequestType, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: RFSActionType.REPORT_SELECT_LIST_REQUEST_TYPE_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* reportSelectListProjectAsync(action) {
  const result = yield call(reportSelectListProject, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: RFSActionType.REPORT_SELECT_LIST_PROJECT_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* reportSelectListLotAsync(action) {
  const result = yield call(reportSelectListLot, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: RFSActionType.REPORT_SELECT_LIST_LOT_SUCCESS,
        data: result.data
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* getRFSHistoryAsync(action) {
  const result = yield call(getRFSHistory, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({ type: RFSActionType.GET_RFS_HISTORY_SUCCESS, data: result.data })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* addScheduleRequestAsync(action) {
  const result = yield call(
    sendAjaxRequest,
    AppSettings.CURRENT_SITE_URI,
    '/api/request-for-services/schedule',
    action.payload,
    'POST'
  );
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({
        type: RFSActionType.ADD_SCHEDULE_RFS_SUCCESS,
        data: {
          data: result.data
        }
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'RFS created' })
    ];
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* updateRFSManageByAsync(action) {
  const result = yield call(updateRFSManageBy, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({
        type: RFSActionType.GET_BY_RFS_ID_ASYNC,
        params: action.params.refNo,
        callback: action.callback
      }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* updateRFSRequestTypeAsync(action) {
  const result = yield call(updateRFSRequestType, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' }),
      put({
        type: RFSActionType.GET_BY_RFS_ID_ASYNC,
        params: action.params.refNo,
        callback: action.callback
      })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

//HOMEOWNER
export function* addHomeownerRequestAsync(action) {
  const result = yield call(AddHomeownerRequest, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
    // yield [
    //   put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Request created' })
    // ];
  } else {
    if (action.callback) {
      action.callback(false, result.data);
    }
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* signOffMultipleHomeownerWorkOrderAsync(action) {
  const result = yield call(signOffMultipleHomeownerWorkOrder, action.params);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* exportRFSListAsync(action) {
  const result = yield call(exportRFSList, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    //get file name
    let filename = 'RequestsForService.xlsx';
    let disposition = result.headers['content-disposition'];
    if (disposition) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      if (matches !== null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    let blob = new Blob([result.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    if (window.navigator.msSaveOrOpenBlob) {
      // for IE browser
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // for Non-IE (chrome, firefox etc.)
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data[0] });
  }
}

export function* reassignMultipleRFSAsync(action) {
  const result = yield call(reassignMultipleRFS, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}
//PRINT PREVIEW FOR RFS SAGA
export function* printPreviewRFSAsync(action) {
  const result = yield call(printPreviewRFS, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* fetchRequestElectricOrientationCheckListAsync(action) {
  const result = yield call(fetchRequestElectricOrientationCheckList, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RFSActionType.GET_EOC_DETAIL_SUCCESS, data: result.data});
    if (action.callback) {
      action.callback(result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* fetchRequestElectricOrientationCheckList2Async(action) {
  const result = yield call(fetchRequestElectricOrientationCheckList2, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RFSActionType.GET_EPL_DETAIL_SUCCESS, data: result.data});
    if (action.callback) {
      action.callback();
    }
  }
  else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.Message});
  }
}

export function* getCheckEPLIsAvailableAsync(action) {
  const result = yield call(getCheckEPLIsAvailable, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback(result.data);
    }
  }
  else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.Message});
  }
}

export function* printEOCTemplateAsync(action) {
  const result = yield call(printEOCTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* printEOFTemplateAsync(action) {
  const result = yield call(printEOFTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback(true, result.data);
    }
  } else {
    if (action.callback) {
      action.callback(false);
    }
  }
}

export function* printEPLTemplateAsync(action) {
  const result = yield call(printEPLTemplate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    let filename = `EPL-${action.params && action.params.RefNo ? action.params.RefNo : 'report'}.pdf`;
    const disposition =
      result.headers &&
      (result.headers['content-disposition'] ||
        result.headers['Content-Disposition']);

    if (disposition) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches !== null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    const contentType =
      (result.headers &&
        (result.headers['content-type'] || result.headers['Content-Type'])) ||
      'application/pdf';
    const blob = new Blob([result.data], { type: contentType });

    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      const downloadUrl = window.URL.createObjectURL(blob);
      link.href = downloadUrl;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 100);
    }

    if (action.callback) {
      action.callback(true);
    }
  } else {
    if (action.callback) {
      action.callback(false);
    }
  }
}

export function* requestSignatureEOCAsync(action) {
  const result = yield call(requestSignatureEOC, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* requestCheckListSignatureEOCAsync(action) {
  const result = yield call(requestCheckListSignatureEOC, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* requestCheckListsApprovalEOCAsync(action) {
  const result = yield call(requestCheckListsApprovalEOC, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* submitElectricOrientationCheckListsAsync(action) {
  const result = yield call(submitElectricOrientationCheckLists, action.params);
  const statusCode = result.statusCode;
  if (statusCode === 200) {
    if(!action.isPrint){
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'})
    ];
  }
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* submitElectricOrientationCheckLists2Async(action) {
  const result = yield call(submitElectricOrientationCheckLists2, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'})
    ];

    if (action.callback) {
      action.callback(true);
    }
  } else {
    if (action.callback) {
      action.callback(false, result.data);
    }
  }
}

export function* eocTemplateHomeownerAsync(action) {
  const result = yield call(eocTemplateHomeowner, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RFSActionType.EOC_TEMPLATE_HOMEOWNER_SUCCESS, data: result.data})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* eocSubmitTemplateHomeownerAsync(action) {
  const result = yield call(eocSubmitTemplateHomeowner, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* getRFSEndpointAsync(action) {
  const result = yield call(getRFSEndpoint, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: RFSActionType.GET_GLOBAL_ENDPOINT_RFS_SUCCESS, data: result.data})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* uploadS3SignatureAsync(action) {
  const result = yield call(uploadS3Signature, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) { action.callback(result.data); }
  } else {
    yield put({type: NotifyActionType.NOTIFY_ERROR, data: result.data});
  }
}

export function* saveEocFormToLotDocumentAsync(action) {
  const result = yield call(saveEocFormToLotDocument, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved'})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* sendEOCTemplateEmailAsync(action) {
  const result = yield call(sendEOCTemplateEmail, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({type: NotifyActionType.NOTIFY_SUCCESS, data: 'Sent'})
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* sendEPLTemplateEmailAsync(action) {
  const result = yield call(sendEPLTemplateEmail, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [put({type: NotifyActionType.NOTIFY_SUCCESS, data: 'Sent'})];

    if (action.callback) {
      action.callback(true);
    }
  }
  else {
    if (action.callback) {
      action.callback(false);
    }
  }
}

export function* getEmailPrimaryHomeownerAsync(action) {
  const result = yield call(getEmailPrimaryHomeowner, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({type: RFSActionType.GET_EMAIL_PRIMARY_HOMEOWNER_SUCCESS, data: result.data})
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}

export function* fetchCreatedByAsync(action) {
  const result = yield call(fetchCreatedBy, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RFSActionType.FETCH_CREATED_BY_RFS_SUCCESS, data: result.data});
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}
export function* setUpdatedFilterForWOAsync(action) {
  console.log('UPDATED_FILTER_VALUE_FOR_WO_SUCCESS', action)
  const result = action.payload;
  yield put({ type: RFSActionType.UPDATED_FILTER_VALUE_FOR_WO_SUCCESS, data: result});
  if (action.callback) {
    action.callback(result);
  }
}

export function* updateWOReassignValueAsync(action) {
  const result = yield call(updateWOReassignValue, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [put({ type: RFSActionType.UPDATE_WO_RASSIGN_VALUE_SUCCESS, data: result.data}),
      put({type: NotifyActionType.NOTIFY_SUCCESS, data: 'Update Successfully'})];

    if (action.callback) {
      action.callback();
    }
  }
  else {
    if (action.callback) {
      action.callback(false);
    }
  }
}


export function* fetchFilterWOAsync(action) {
  const result = action.payload;
  yield put({ type: RFSActionType.FILTER_WO_SUCCESS, data: result});
}
export function* filterPreviewWO(action) {
  const result = action.payload;
  yield put({ type: RFSActionType.FILTER_PREVIEW_WO_SUCCESS, data: result});
}
// export function* fetchAverageAgeofRFS(action) {
//   const result = yield call(fetchAverageAgeAPI, action.params);
//   const statusCode = result.statusCode;

//   if (statusCode === 200) {
//     yield put({ type: RFSActionType.FETCH_AVERAGE_AGE_OF_RFS_SUCCESS, data: result.data});
//   } else {
//     yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
//   }
// }

export function* getRFSREviewDateAsync(action) {
  const result = yield call(getRFSREviewDate, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: RFSActionType.GET_RFS_REVIEW_DATE_SUCCESS, data: result.data});
    if (action.callback) {
      action.callback();
    }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error});
  }
}


export default function* WatchRFS() {
  yield all([
    takeLatest(RFSActionType.GET_BY_RFS_ID_ASYNC, getByRFSIDAsync),
    takeLatest(RFSActionType.SEARCH_RFS_ASYNC, searchAsync),
    takeEvery(RFSActionType.AWAITING_REVIEW_RFS_ASYNC, awaitingReviewAsync),
    takeEvery(RFSActionType.APPROVE_RFS_ASYNC, approveAsync),
    takeEvery(RFSActionType.CLOSE_RFS_ASYNC, closeAsync),
    takeEvery(RFSActionType.ADD_RFS, addRFSAsync),
    takeLatest(
      RFSActionType.GET_LIST_WORK_ORDER_BY_RFSID_ASYNC,
      getListWorkOrderByRFSIDAsync
    ),
    takeLatest(
      RFSActionType.SIGNOFF_MULTIPLE_WORK_ORDER_ASYNC,
      signoffMultipleWorkOrderAsync
    ),
    takeLatest(
      RFSActionType.REPORT_SELECT_LIST_REGION_ASYNC,
      reportSelectListRegionAsync
    ),
    takeLatest(
      RFSActionType.REPORT_SELECT_LIST_MARKET_ASYNC,
      reportSelectListMarketAsync
    ),
    takeLatest(
      RFSActionType.REPORT_SELECT_LIST_PROJECT_ASYNC,
      reportSelectListProjectAsync
    ),
    takeLatest(
      RFSActionType.REPORT_SELECT_LIST_REQUEST_TYPE_ASYNC,
      reportSelectListRequestTypeAsync
    ),
    takeLatest(
      RFSActionType.REPORT_SELECT_LIST_LOT_ASYNC,
      reportSelectListLotAsync
    ),
    takeLatest(RFSActionType.GET_RFS_HISTORY_ASYNC, getRFSHistoryAsync),
    takeLatest(
      RFSActionType.HOMEOWNER_ADD_REQUEST_ASYNC,
      addHomeownerRequestAsync
    ),
    takeLatest(
      RFSActionType.UPDATE_RFS_WITHOUT_CHANGE_STATUS_ASYNC,
      updateRFSWithoutChangeStatusAsync
    ),
    takeLatest(
      RFSActionType.SIGNOFF_MULTIPLE_HOMEOWNER_WORK_ORDER_ASYNC,
      signOffMultipleHomeownerWorkOrderAsync
    ),
    takeLatest(RFSActionType.ADD_SCHEDULE_RFS_ASYNC, addScheduleRequestAsync),
    takeLatest(
      RFSActionType.UPDATE_RFS_MANAGE_BY_ASYNC,
      updateRFSManageByAsync
    ),
    takeLatest(RFSActionType.EXPORT_RFS_LIST, exportRFSListAsync),
    takeLatest(
      RFSActionType.REASSIGN_MULTIPLE_RFS_ASYNC,
      reassignMultipleRFSAsync
    ),
    takeLatest(RFSActionType.PRINT_PREVIEW_RFS_ASYNC, printPreviewRFSAsync),
    takeLatest(RFSActionType.GET_EOC_DETAIL_ASYNC, fetchRequestElectricOrientationCheckListAsync),
    takeLatest(RFSActionType.GET_EPL_DETAIL_ASYNC, fetchRequestElectricOrientationCheckList2Async),
    takeLatest(RFSActionType.GET_EPL_IS_AVAILABLE_ASYNC, getCheckEPLIsAvailableAsync),
    takeLatest(RFSActionType.PRINT_EOC_TEMPLATE_ASYNC, printEOCTemplateAsync),
    takeLatest(RFSActionType.PRINT_EOF_TEMPLATE_ASYNC, printEOFTemplateAsync),
    takeLatest(RFSActionType.PRINT_EPL_TEMPLATE_ASYNC, printEPLTemplateAsync),
    takeLatest(
      RFSActionType.REQUEST_SIGNATURE_ASYNC,
      requestSignatureEOCAsync
    ),
    takeLatest(
      RFSActionType.REQUEST_CHECKLISTS_SIGNATURE_ASYNC,
      requestCheckListSignatureEOCAsync
    ),
    takeLatest(
      RFSActionType.REQUEST_CHECKLISTS_APPROVAL_ASYNC,
      requestCheckListsApprovalEOCAsync
    ),
    takeLatest(RFSActionType.SUBMIT_EOC_LIST_ASYNC, submitElectricOrientationCheckListsAsync),
    takeLatest(RFSActionType.SUBMIT_EPL_LIST_ASYNC, submitElectricOrientationCheckLists2Async),
    takeLatest(
      RFSActionType.EOC_TEMPLATE_HOMEOWNER_ASYNC,
      eocTemplateHomeownerAsync
    ),
    takeLatest(
      RFSActionType.GET_GLOBAL_ENDPOINT_RFS_ASYNC,
      getRFSEndpointAsync
    ),
    takeLatest(
      RFSActionType.EOC_SUBMIT_TEMPLATE_HOMEOWNER_ASYNC,
      eocSubmitTemplateHomeownerAsync
    ),
    takeLatest(
      RFSActionType.HOMEOWNER_RFS_SETUP_AWS_ASYNC,
      homeownerRFSSetupAWSAsync
    ),
    takeLatest(
      RFSActionType.SETUP_RFS_UPLOAD_SIGNATURE_S3,
      uploadS3SignatureAsync
    ),
    takeLatest(
      RFSActionType.SAVE_EOC_TEMPLATE_TO_LOT_DOCUMENT_ASYNC,
      saveEocFormToLotDocumentAsync
    ),
    takeLatest(RFSActionType.SEND_EOC_TEMPLATE_EMAIL_ASYNC, sendEOCTemplateEmailAsync),
    takeLatest(RFSActionType.SEND_EPL_TEMPLATE_EMAIL_ASYNC, sendEPLTemplateEmailAsync),
    takeLatest(
      RFSActionType.GET_EMAIL_PRIMARY_HOMEOWNER_ASYNC,
      getEmailPrimaryHomeownerAsync
    ),
    takeLatest(
      RFSActionType.UPDATE_RFS_REQUEST_TYPE_ASYNC,
      updateRFSRequestTypeAsync
    ),
    takeLatest(
      RFSActionType.FETCH_CREATED_BY_RFS,
      fetchCreatedByAsync
    ),
    takeLatest(
      RFSActionType.FILTER_WO,
      fetchFilterWOAsync
    ),
    takeLatest(
      RFSActionType.PREVIEW_WO_LIST,
      filterPreviewWO
    ),    
    takeLatest(RFSActionType.UPDATED_FILTER_VALUE_FOR_WO,setUpdatedFilterForWOAsync),
    takeLatest(RFSActionType.UPDATE_WO_RASSIGN_VALUE,updateWOReassignValueAsync),
    // takeLatest(RFSActionType.FETCH_AVERAGE_AGE_OF_RFS, fetchAverageAgeofRFS),
    takeLatest(RFSActionType.GET_RFS_REVIEW_DATE, getRFSREviewDateAsync),
  ]);
}



// WEBPACK FOOTER //
// ./src/Request-Services/saga.js